module.exports = __webpack_public_path__ + "img/BJT3.68c915a4.svg";